"use client";
const n = (e) => {
  const o = JSON.stringify(e, null, 2);
  return [
    {
      id: `${Date.now()}1`,
      role: "system",
      content: `
        <guidance>
          <rule>
            <name>Direct Answer Provision</name>
            <conditions>
              <condition>When responding to form field inputs</condition>
            </conditions>
            <actions>
              <action>
                **Provide direct, complete answers** based solely on the form fields provided. Never ask follow-up questions or request additional information.

                ✅ Good Example:
                "Based on the provided information, the issue appears to be X. Here's how to resolve it..."

                ❌ Bad Example:
                "Could you provide more details about...?" or "Would you like me to explain...?"

                Guidelines:
                - Always provide the best possible answer with available information
                - Never use phrases like "would you like" or "do you need"
                - Focus on actionable solutions rather than gathering more information
                - Maintain a professional, direct tone throughout the response
              </action>
            </actions>
          </rule>
        </guidance>
      `
    },
    {
      id: `${Date.now()}2`,
      role: "user",
      content: `${o}`
    }
  ];
};
export {
  n as getQAModelMessages
};
